
import LogisticsBill from '@/models/operator/logistics-bill'
import PaginationTpl from "components/base/PaginationTpl";
import statusMixins from '@/common/mixins/status.js'
import { numsToRMBSymbolAndMillimeter, downLoadFileByBlob } from "common/js/util";
const STATUS = { 1: '待核实', 2: '已核实' }
export default {
  mixins: [statusMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      menuList: [
        { name: '日账单', url: '/operate/dues/logisticsBill/logisticsDateBill' },
        { name: '月账单', url: '/operate/dues/logisticsBill/logisticsMonthBill' },
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        { label: '日期', prop: 'billDate', width: '', alignment: 'left' },
        { label: '物流公司名称', prop: 'companyName', width: '', alignment: 'left' },
        { label: '快递类型', prop: 'expressName', width: '', alignment: 'left' },
        { label: '单量', prop: 'orderNums', width: '', alignment: 'right' },
        { label: '金额', prop: 'amount', width: '', alignment: 'right' },
        { label: '账单状态', prop: 'statusVal', width: '', alignment: 'left' }
      ],
      // 多个账单导出id集合
      billIdList: [],
    }
  },

  created() {
  },

  methods: {
    /**
     * @desc 账单列表
     */
    initLogisticsBillList() {
      let currentPage = this.currentPage
      let type = this.search.select
      let reportDate
      if (type === 1) {
        reportDate = this.search.date ? this.search.date : ''
      } else {
        reportDate = this.search.month ? this.search.month : ''
      }
      let data = {
        type,
        reportDate,
        currentPage
      }
      LogisticsBill.getLogisticsBillList(data).then(res => {
        if (res.success) {
          let { totalNum, pageSize, items } = res.result
          this.total = totalNum
          this.pageSize = pageSize
          let arr = []
          items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.billDate = i.reportDate
            obj.companyName = i.companyName
            obj.expressName = i.expressTypeName
            obj.orderNums = i.orderNum
            obj.status = i.status
            obj.statusVal = STATUS[i.status];
            obj.amount = numsToRMBSymbolAndMillimeter(i.totalCost);
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    toUrl(v) {
      this.$router.push({
        path: v,
      });
    },

    searchList() {
      this.currentPage = 1
      this.initLogisticsBillList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.search.date = ''
      this.search.month = ''
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex == 4 || columnIndex == 5) {
        return 'right-align'
      }
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initLogisticsBillList()
    },

    /**
     * @desc 核实账单
     */
    batchVerification(id) {
      this.$confirm("核实后，该账单将不可再次修改，请确认", "核实", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          id
        }
        LogisticsBill.postVerify(data).then(res => {
          if (res.success) {
            this.initLogisticsBillList()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    /**
     * @desc 导出账单
     */
    exportExcel() {
      let type = this.search.select
      let reportDate
      if (type === 1) {
        reportDate = this.search.date ? this.search.date : ''
      } else {
        reportDate = this.search.month ? this.search.month : ''
      }
      let data = {
        type,
        reportDate,
      }
      LogisticsBill.getExport(data).then((res) => {
        downLoadFileByBlob(res)
      });
    },

    /**
     * @desc 所选中的商品数据
     */
    handleSelectionChange(val) {
      let arr = []
      val.map(i => {
        arr.push(i.id)
      })
      this.billIdList = arr
    },
  }
}